import type { ComponentImportProgressState } from "@/editor/store/editorStoreTypes";

export function ComponentImportProgressToast({
  progress,
}: {
  progress: ComponentImportProgressState;
}) {
  const total = Math.max(1, progress.total);
  const value = progress.phase === "previews"
    ? Math.min(1, Math.max(0, progress.current / total))
    : progress.phase === "importing"
      ? 0.18
      : 0.08;
  const label = progress.phase === "reading"
    ? "Reading .curva file"
    : progress.phase === "importing"
      ? "Importing components"
      : `Preparing previews ${Math.min(progress.current, progress.total)} of ${progress.total}`;

  return (
    <div className="pointer-events-none absolute bottom-10 right-4 z-30 w-72 rounded-md border border-white/10 bg-[#20262d] p-3 text-slate-200 shadow-xl shadow-black/30">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[12px] font-medium text-slate-100">Importing components</div>
          <div className="mt-0.5 truncate text-[11px] text-slate-400">{progress.filename}</div>
        </div>
        <div className="shrink-0 text-[11px] tabular-nums text-slate-400">{Math.round(value * 100)}%</div>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-black/40">
        <div
          className="h-full rounded-full bg-sky-400 transition-[width] duration-200"
          style={{ width: `${Math.round(value * 100)}%` }}
        />
      </div>
      <div className="mt-2 text-[11px] leading-4 text-slate-400">
        {label}. Large component libraries can take a moment.
      </div>
    </div>
  );
}
